/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_About_Method_HeadingInputs */

const ja_playdata_about_method_heading = /** @type {(inputs: Playdata_About_Method_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`データ収集の方法`)
};

const en_playdata_about_method_heading = /** @type {(inputs: Playdata_About_Method_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How data is collected`)
};

/**
* | output |
* | --- |
* | "How data is collected" |
*
* @param {Playdata_About_Method_HeadingInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const playdata_about_method_heading = /** @type {((inputs?: Playdata_About_Method_HeadingInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_About_Method_HeadingInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_about_method_heading(inputs)
	return en_playdata_about_method_heading(inputs)
});